let preference = {
    title: "个人偏好",
    num: "次",
    time: "时",
    select: {
        title: '显示最近',
        option01: "一周",
        option02: "二周",
        option03: "三周",
        option04: "一月",
        option05: "二月",
        option06: "三月",
    },
    apply: {
        title: "常用应用"
    },
    authentication: {
        title: "常用认证方式"
    },
    cause: {
        title: "认证失败原因"
    },
    facility: {
        title: "常用设备"
    },
    location: {
        title: "常用位置"
    },
    timeFrame: {
        title: "认证时段分布"
    },
}

export default preference